import styled from "styled-components";

export const Step = styled.div<{isActive: boolean}>`
  display: ${({isActive}) => isActive ? 'flex' : 'none'};
  padding: 100px 200px;
  width: 100%;
  height: 100%;
  background: ${({theme}) => theme.business.colors.primaryBackground};
  flex-direction: column;
  gap: 100px;
`

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
`